import { render, staticRenderFns } from "./FansTab.vue?vue&type=template&id=1273a79a"
import script from "./FansTab.vue?vue&type=script&setup=true&lang=js"
export * from "./FansTab.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports